<template>
  <div class="coursedetails">
    <!-- 视频 -->
    <div class="details_bgvd">
      <div class="details_warp">
        <div class="deta_bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>公开课</el-breadcrumb-item>
            <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      
        <div class="video_center" >
            <!-- 视频 -->
        <div class="vidall" v-if="vidshow == false">
				<!-- 课程封面 -->
				<div class="vid_cover" @click="play">
					<div class="playicon">
            <i class="el-icon-video-play"></i>
          </div>
				</div>
				<img :src="cover" alt="" />
		   	</div>
        
          <video
          v-else
            controls
            disablePictureInPicture
            controlslist="nodownload  noremoteplayback noplaybackrate "
            :src="vidurl"
            autoplay
            id="videos"
            @timeupdate="timeupdate"
            ref="vidmy"
          >
           
            您的浏览器不支持 HTML5 video 标签。
          </video>
          <!-- 标题 -->
          <div class="vid_title">
            <span class="title_txts">{{title}}</span>
            <span class="curnums"
              >{{createTime}}</span
            >
          </div>
        </div>
      </div>
    </div>
   
    <!-- 介绍目录 -->
    <div class="courwarp">
      <div class="courcenter">
        <div class="couret_left">
          <!-- 头部 -->
          <div class="couret_heder">
            <div style="margin-top: 14px">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="课程介绍" name="first">
                  <div class="cur_jieshao">
                    <p v-html="courselist.description"></p>
                    <p style="margin-top: 10px" v-html="synopsis"></p>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openclassget } from "@/api/coursedetails";

export default {
  name: "openclass",
  data() {
    return {
      courselist:{},
	  vidurl:'',
	  synopsis:'',
	  cover:'',
	  title:'',
	  createTime:'',
      vidshow:false,
      endshow:false,
      activeName: "first",
    loadingwarp:null,
   };
  },
  created(){
    this.$store.commit('user/SET_TABINDEX',1);
  },
  mounted() {
    this.courseId = this.$route.query.id;
    //课程详情
    this.coursedet(this.courseId);
  },
  methods: {
    // 课程详情
    coursedet(id) {
       this.loadingwarp =  this.$loading({
          lock: true,
          text: '努力加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      openclassget(id).then((res) => {
       if(res.code==200&&res.rows.length>0){
					const {title,videoUrl,description,cover,createTime} = res.rows[0]
					this.vidurl = videoUrl
					this.synopsis = description
					this.cover = cover
					this.title = title
					this.createTime = createTime
				}
				this.archivesList = res.rows;
        //关闭Loading
        this.loadingwarp.close();
      });
    },
    // tab切换
    handleClick(tab, event) {
      
    },
    // 播放
    play() {
		if (this.vidurl == '') {
        this.$message({
          message:"暂时没有课程资源",
          type:"error"
        })
			} else {
				// 试看
				this.vidshow = true;

			
			}
	 },
     // 退出全屏
    exitfull() {
     document.exitFullscreen();
   },
   timeupdate(e){
     var currentTime = parseInt(e.target.currentTime);
     if(currentTime ==10){
       console.log("aaa")

       this.exitfull();
       console.log("c")
  
     }else if(currentTime==15){
 
      this.exitfull();
      console.log("c")

     }
   }
  },
};
</script>
<style lang="scss" scoped>
.coursedetails {
  width: 100%;
  min-height: 100vh;
  background-color: #f6f6f6;
  .details_bgvd {
    width: 100%;
    height: 700px;
    overflow: hidden;
    background-color:#292929;
    .details_warp {
      width: 1200px;
      margin: 0 auto;
      
		.vidall {
			width: 800px;
      height: 500px;
      margin: 20px auto;
			overflow: hidden;
			position: relative;
			// 课程封面
			.vid_cover {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				background-color: rgba(0, 0, 0, 0.3);
		
				.playicon {
          font-size: 75px;
          color: #ffffff;
					border-radius: 50%;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
          cursor: pointer;
				}
			}

			// 返回Icon
			.arrleft {
				position: absolute;
				left: 0%;
				top: 5%;
				z-index: 10;
			}
			img {
				width: 100%;
				height: 500px;
			}
		}
		// 试看两分钟结束的icon
		.endwarp {
			width: 100%;
			height: 450px;
			background-color: #000000;
			overflow: hidden;
			position: relative;
			// margin-top: 60px;
			.endicon {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				z-index: 10;
			}
			// 返回Icon
			.arrleft {
				position: absolute;
				left: 0%;
				top: 5%;
				z-index: 10;
			}
		}
      .deta_bread {
        padding-top: 30px;
        ::v-deep {
          .el-breadcrumb__item {
            font-size: 16px;
          }
        }
        ::v-deep .el-breadcrumb__inner {
          color: #999999 !important;
        }
      }
      // 视频
      .video_center {
        width: 800px;
        height: 500px;
        margin: 20px auto;
        cursor: pointer;
        video {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
      //标题
      .vid_title {
        width: 100%;
        margin-top: 15px;
        overflow: hidden;
        .title_txts {
          width: 85%;
          font-size: 30px;
          font-weight: bold;
          color: #ffffff;
          float: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .curnums {
          float: right;
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
        }
      }
      // 报名按钮
      .promptly_wap {
        width: 100%;
        margin-top: 20px;
        overflow: hidden;
        .promptly_btns {
          min-width: 130px;
          height: 40px;
          line-height: 15px;
          font-size: 18px;
          float: left;
        }
        span {
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          float: right;
          margin-top: 5px;
        }
      }
    }
  }
  // 二维码
  .img_code{
    width: 200px;
    height: 200px;
    margin: 0 auto;
    .qrcode{
      width: 100%;
      height: 100%;
    }
  }
  // 内容介绍
  .courwarp {
    width: 100%;
    background-color: #f6f6f6;
    overflow: hidden;
    // 中间内容
    .courcenter {
      width: 1200px;
      margin: 30px auto;
      overflow: hidden;

      // 左侧
      .couret_left {
        width: 850px;
        min-height: 700px;
        border-radius: 5px;
        box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        padding-bottom: 30px;
        margin: 0 auto;
      }
      // 头部
      .couret_heder {
        width: 90%;
        margin: 0 auto;
        .cur_jieshao {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 1.7;
          text-indent: 20px;
        }
      }
    }
  }
}
</style>
